import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { ssColorBlack, ssColorDarkGrey, mediaBreakpointUpSM } from '../constants/style-constants';
import CompleteIcon from './icons/CompleteIcon';
import { vunit } from '../lib/style-helpers';

const containerCss = css`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const iconsCss = css`
  align-items: center;
  justify-content: space-between;
  display: flex;
  position: relative;
  width: 100%;

  &::before {
    background: ${ssColorDarkGrey};
    content: "";
    height: 1px;
    display: inline-block;
    position: absolute;
    top: calc(50% + 1px);
    width: 100%;
  }
`;

const iconSize = '16px';

const iconCss = css`
  height: ${iconSize};
  position: relative;
  width: ${iconSize};
`;

const IncompleteIcon = styled.span`
  background: ${ssColorBlack};
  border-radius: 50%;
  border: 2px solid ${ssColorDarkGrey};
  display: inline-block;
  height: ${iconSize};
  width: ${iconSize};
`;

const labelCss = css`
  font-size: 1rem;
  margin-bottom: ${vunit(1)};
  text-align: center;

  ${mediaBreakpointUpSM} {
    font-size: 1.2rem;
  }
`;

const renderIcon = (total, index, count) => (
  index < count ? <CompleteIcon /> : <IncompleteIcon />
);

const ProgressBar = ({
  label, total, count, ...rest
}) => (
  <div css={containerCss} {...rest}>
    <span css={labelCss}>{label.replace('{total}', total).replace('{count}', count)}</span>
    <div css={iconsCss}>
      {[...Array(total).keys()].map(index => (
        <span key={index} css={iconCss}>{renderIcon(total, index, count)}</span>
      ))}
    </div>
  </div>
);

ProgressBar.propTypes = {
  label: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
};

export default ProgressBar;
